import { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import api from "../lib/api";
import { X, Megaphone } from "lucide-react";

const priorityStyle = {
  info: "border-blue-500/30 bg-blue-500/5",
  success: "border-emerald/30 bg-emerald/5",
  warning: "border-yellow-500/30 bg-yellow-500/5",
  critical: "border-red-500/30 bg-red-500/5",
};

const AnnouncementBanner = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/announcements/me");
        setItems(r.data || []);
      } catch { /* silent */ }
    })();
  }, []);

  const dismiss = async (id) => {
    try {
      await api.post(`/announcements/${id}/dismiss`);
      setItems((p) => p.filter((a) => a.id !== id));
    } catch { /* silent */ }
  };

  if (items.length === 0) return null;

  return (
    <div className="space-y-2 mb-6" data-testid="announcement-banners">
      {items.map((a) => (
        <Card key={a.id} className={`border ${priorityStyle[a.priority] || priorityStyle.info}`} data-testid={`banner-${a.id}`}>
          <CardContent className="p-4 flex items-start gap-3">
            <Megaphone className="text-gold shrink-0 mt-0.5" size={18} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <h4 className="font-medium text-foreground">{a.title}</h4>
                <Badge variant="outline" className="text-xs uppercase">{a.priority}</Badge>
              </div>
              <p className="text-sm text-muted-foreground whitespace-pre-wrap">{a.body}</p>
              <p className="text-xs text-muted-foreground mt-2">— {a.created_by_name || "EchoSense Capital Club"}</p>
            </div>
            <Button variant="ghost" size="sm" onClick={() => dismiss(a.id)} data-testid={`dismiss-${a.id}`}>
              <X size={14} />
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AnnouncementBanner;
